import React from 'react'
import {
    StyledPromoCard,
    StyledPromoImg,
    StyledPromoLink,
} from '../PromoCard.styled'

export const TheGamePromoCard = () => {
    const promo = require('../assets/the-game.webp')
    return (
        <StyledPromoCard promotion="the-game">
            <StyledPromoLink
                to="https://thegame.com.au/play?utm_source=Acquisition&utm_medium=AFL+Page&utm_campaign=AFLW+2026&utm_term=Weekly+Prize&utm_content=TWA"
                openExternalInNewWindow
            >
                <StyledPromoImg
                    src={promo}
                    alt="The Game AFLW Tipping Competition. Tip Now."
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}
